import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService, LanguageCode, OnlinePaymentMethod } from '@interticket/core';
import { PAYMENT_URLS } from '@core/configs/payment-url.config';

@Pipe({
  name: 'paymentUrl',
  pure: false,
})
export class PaymentUrl implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(paymentType: OnlinePaymentMethod): string {
    if (PAYMENT_URLS[paymentType]) {
      return PAYMENT_URLS[paymentType][this.translate.currentLang] || PAYMENT_URLS[paymentType][LanguageCode.EN];
    }
    return '';
  }

}
